/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
// Dashboard components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

// Dashboard example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";

import CloseIcon from "@mui/icons-material/Close";
import Alert from "@mui/material/Alert";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import MDCard from "components/MDCard";

// Notification
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Functions from store
import {
  createDynamicColumn,
  getDynamicColumn,
  getSubModulesByRoleId,
  getSuids,
  getWarehouses,
  getWmsStock,
  getWmsStockDownload,
} from "../../../store";

import { CSVLink } from "react-csv";

// Cookies
import { Backdrop, CircularProgress } from "@mui/material";
import DownloadDataButton from "components/standardized-components/DownloadDataButton";
import Cookies from "universal-cookie";

import { addMinutes, format } from "date-fns";

import Config from "../../../config/index";

const cookies = new Cookies();
const desLength = Config.descriptionLength;

const WmsStock = ({
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,
  warehouses,
  getWarehouses,
  getWmsStock,
  getWmsStockReducer,
  downloadWmsStockReducer,
  getWmsStockDownload,
  getDynamicColumnReducer,

  createDynamicColumn,
  getDynamicColumn,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");
  const styleForColumnReorder = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 380,
    color: "black",
    // border: "2px solid #000",
    boxShadow: 24,
    p: 2,
    pt: 3,
  };

  let jwtToken = loginDetails?.jwt;
  let roleId = loginDetails.data.roleId;

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);
  useEffect(() => {
    getWarehouses(jwtToken);
  }, []);
  const [warehouseIdSelected, setWarehouseIdSelected] = useState("");
  const [selectedAllStock, setSelectedAllStock] = useState("");

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  let wmsStockModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "9ff84c7e-8036-4e8c-9953-52dd66ae820a",
  );

  let viewWmsStockOccupancy = wmsStockModule
    ? wmsStockModule.actionId.includes("1d97c139-638e-4d1b-a395-b32e731f4287")
    : null;

  const navigate = useNavigate();

  const controlOptions = [
    {
      label: "All control",
      value: "",
    },
    {
      label: "No Control",
      value: 0,
    },
    {
      label: "Serial Control",
      value: 1,
    },
    {
      label: "Lot Control",
      value: 2,
    },
  ];

  const [state, setState] = useState({
    columns: [
      { Header: "Item Code", accessor: "itemCode" },
      {
        Header: "Item Description",
        accessor: "itemDescription",
        align: "left",
        width: 320,
      },
      // { Header: "Category Code", accessor: "categoryCode" },
      {
        Header: "Category Code",
        accessor: "categoryCode",
      },
      {
        Header: "Control Type",
        accessor: "controlType",
        searchType: "select",
        selectOptions: controlOptions,
        placeholder: "All Control",
      },
      { Header: "Qty", accessor: "qty" },
      { Header: "Uom", accessor: "uom" },
      {
        Header: "Created Date",

        accessor: "cd",
        align: "left",
        searchType: "date",
        Cell: ({ value }) => {
          return value
            ? format(
                addMinutes(
                  new Date(value),
                  new Date(value).getTimezoneOffset(),
                ),
                "dd/MM/yyyy hh:mm aaa",
              )
            : "";
        },
      },
    ],
    rows: [],
  });
  const { columns, rows } = state;

  const [pageNo, setPageNo] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchObject, setSearchObject] = useState(JSON.stringify({}));
  const [paginationObj, setPaginationObj] = useState({});
  const [errorMsgFromApi, setErrorMsgFromApi] = useState("");

  const importPageNo = (pageIndex) => {
    setPageNo(pageIndex === -1 ? pageNo : pageIndex);
  };

  const importRowsPerPage = (pageSize) => {
    setRowsPerPage(pageSize);
  };

  const importSearch = (globalFilter) => {
    setSearchObject(globalFilter ? JSON.stringify(globalFilter) : "");
  };
  const [refresh, setRefresh] = useState("");
  // setTimeout(() => {
  //   setRefresh(!refresh);
  // }, 60000);

  useEffect(() => {
    getWmsStock(
      pageNo,
      rowsPerPage,
      searchObject,
      warehouseIdSelected ? warehouseIdSelected.value : "",
      selectedAllStock ? selectedAllStock.value : "",
      jwtToken,
    );
  }, [
    pageNo,
    rowsPerPage,
    searchObject,
    warehouseIdSelected,
    selectedAllStock,
  ]);

  useEffect(() => {
    getWmsStockDownload(
      pageNo,
      rowsPerPage,
      searchObject,
      warehouseIdSelected ? warehouseIdSelected.value : "",
      selectedAllStock ? selectedAllStock.value : "",
      jwtToken,
    );
  }, [
    pageNo,
    rowsPerPage,
    searchObject,
    warehouseIdSelected,
    selectedAllStock,
  ]);

  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let tempFinishedGoods = [];
    let data = getWmsStockReducer.warehouseOccupancy.data
      ? getWmsStockReducer.warehouseOccupancy.data
      : [];

    setLoading(getWmsStockReducer.loading);

    setPaginationObj(getWmsStockReducer.warehouseOccupancy?.pagination);
    data?.map((finishedGoods) => {
      const formatDate = new Date(finishedGoods.cd);

      let len = desLength;

      // const qtyDisplay = finishedGoods.qty === 0 ? "NA" : finishedGoods.qty;
      // const uomDisplay = finishedGoods.qty === 0 ? "" : finishedGoods.uom;
      const finishedGoodsObject = {
        itemCode: finishedGoods.itemCode,
        itemDescription: (
          <span style={{ display: "flex", alignItems: "center" }}>
            {finishedGoods?.itemDescription?.length > 35 ? (
              <Tooltip
                title={finishedGoods.itemDescription}
                style={{ cursor: "pointer" }}
              >
                <MDTypography
                  variant="h6"
                  fontWeight="regular"
                  style={{ fontSize: "14px" }}
                >
                  {finishedGoods.itemDescription.substring(0, len)}
                </MDTypography>
              </Tooltip>
            ) : (
              <MDTypography
                variant="h6"
                fontWeight="regular"
                style={{ fontSize: "14px" }}
              >
                {finishedGoods.itemDescription}
              </MDTypography>
            )}
            {finishedGoods?.itemDescription?.length > 35 && (
              <span style={{ marginLeft: "0.1rem" }}>...</span>
            )}
          </span>
        ),
        categoryCode: finishedGoods.categoryCode,
        // controlType: finishedGoods.controlType,
        qty: finishedGoods.qty === 0 ? "NA" : finishedGoods.qty,
        uom: finishedGoods.uom,
        createdDate: format(
          addMinutes(formatDate, formatDate.getTimezoneOffset()),
          "dd/MM/yyyy hh:mm aaa",
        ),
        cd: finishedGoods.cd,
        controlType:
          (finishedGoods.controlType === 0 && `No Control`) ||
          (finishedGoods.controlType === 1 && `Serial Control`) ||
          (finishedGoods.controlType === 2 && `Lot Control`),
      };
      tempFinishedGoods.push(finishedGoodsObject);
    });
    setState({ ...state, rows: tempFinishedGoods });
  }, [getWmsStockReducer]);

  const [download, setDownload] = useState("");

  useEffect(() => {
    let tempFinishedGoods = [];
    let data = downloadWmsStockReducer.warehouseOccupancy.data
      ? downloadWmsStockReducer.warehouseOccupancy.data
      : [];
    data?.map((finishedGoods) => {
      const formatDate = new Date(finishedGoods.cd);

      const qtyDisplay = finishedGoods.qty === 0 ? "NA" : finishedGoods.qty;
      const uomDisplay = finishedGoods.uom === 0 ? "" : finishedGoods.uom;
      const finishedGoodsObject = {
        itemCode: finishedGoods.itemCode,
        itemDescription: finishedGoods.itemDescription,
        categoryCode: finishedGoods.categoryCode,
        controlType: finishedGoods.controlType,
        qty: `${qtyDisplay}`,
        uom: ` ${uomDisplay}`,
        createdDate: format(
          addMinutes(formatDate, formatDate.getTimezoneOffset()),
          "dd/MM/yyyy hh:mm aaa",
        ),
        cd: finishedGoods.cd,
        controlType:
          (finishedGoods.controlType === 0 && `No Control`) ||
          (finishedGoods.controlType === 1 && `Serial Control`) ||
          (finishedGoods.controlType === 2 && `Lot Control`),
      };
      tempFinishedGoods.push(finishedGoodsObject);
    });
    setDownload(tempFinishedGoods);
  }, [downloadWmsStockReducer]);

  const headers = [
    {
      label: "itemCode",
      key: "itemCode",
    },
    {
      label: "itemDescription",
      key: "itemDescription",
    },
    { label: "categoryCode", key: "categoryCode" },
    { label: "controlType", key: "controlType" },
    { label: "qty", key: "qty" },
    { label: "uom", key: "uom" },
    { label: "createdDate", key: "createdDate" },
  ];

  const csvLink = {
    filename: "WMS Stock Report.csv",
    headers: headers,
    data: download,
  };
  const allStockOptions = [
    { label: "All Stock", value: true },
    { label: "Not Available", value: false },
  ];

  const handleStockChange = (selectedOption) => {
    setSelectedAllStock(selectedOption);
  };
  const [warehouseOptions, setWarehouseOptions] = useState([]);
  useEffect(() => {
    let tempWarehouseOptions = [];
    let data = warehouses.warehouses ? warehouses.warehouses : [];
    data.map((warehouse) => {
      tempWarehouseOptions.push({
        label: warehouse.warehouseCode,
        value: warehouse.warehouseCode,
        // key: warehouse.warehouseCode,
      });
    });
    setWarehouseOptions(tempWarehouseOptions);
  }, [warehouses]);
  const handleChangeWarehouse = (selectedData) => {
    setWarehouseIdSelected(selectedData);
    setSelectedAllStock("");
  };

  const subModuleId = "9ff84c7e-8036-4e8c-9953-52dd66ae820a";
  let dynamicColumnDetails = cookies.get("dynamic-column-data");
  let userId = loginDetails.data.userId;
  let hiddenColumsDetails = cookies.get("hidden-column-data");

  useEffect(() => {
    getDynamicColumn(userId, subModuleId, jwtToken);
  }, [userId, subModuleId]);

  const [loadingForDynamicColumn, setLoadingForDynamicColumn] = useState(false);
  useEffect(() => {
    let data = getDynamicColumnReducer.dynamicColumn.data
      ? getDynamicColumnReducer.dynamicColumn.data
      : [];

    setDynamicColumnData(data);
    cookies.set("hidden-column-data", JSON.stringify(data?.notVisibleFields), {
      path: "/",
    });

    setTimeout(() => {
      setLoadingForDynamicColumn(true);
    }, 1000);
  }, [getDynamicColumnReducer, loading]);

  const [openCreateColumnReorderModal, setOpenCreateColumnReorderModal] =
    useState(false);

  const handleOpenCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(true);
  };

  const handleCloseCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(false);
  };

  const [dynamicColumnData, setDynamicColumnData] = useState("");
  const [isErrorColumnReorder, setIsErrorColumnReorder] = useState(false);
  const [isSuccessColumnReorder, setIsSuccessColumnReorder] = useState(false);

  useEffect(() => {
    if (isErrorColumnReorder) {
      setTimeout(() => {
        setIsErrorColumnReorder(false);
      }, 3000);
    }
  }, [isErrorColumnReorder]);

  useEffect(() => {
    if (isSuccessColumnReorder) {
      setTimeout(() => {
        setIsSuccessColumnReorder(false);
      }, 3000);
    }
  }, [isSuccessColumnReorder]);

  const [isErrorMsgForColumnReorder, setIsErrorMsgForColumnReorder] =
    useState(false);

  const handleDynamicColumn = async () => {
    let res = await createDynamicColumn(dynamicColumnDetails, jwtToken);
    if (res.status) {
      setIsSuccessColumnReorder(true);
      getDynamicColumn(userId, subModuleId, jwtToken);

      getWmsStock(
        pageNo,
        rowsPerPage,
        searchObject,
        warehouseIdSelected ? warehouseIdSelected.value : "",
        selectedAllStock ? selectedAllStock.value : "",
        jwtToken,
      );
      setTimeout(() => {
        handleCloseCreateColumnReorderModal();
        // window.location.reload();
      }, 2250);
    }
    if (!res.status) {
      setIsErrorColumnReorder(true);
      setIsErrorMsgForColumnReorder(res?.data?.data?.msg);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={3} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                display="flex"
                flexDirection={{ xs: "column", lg: "row" }}
                justifyContent="space-between"
                alignItems="center"
                p={3}
                mb={-3}
                mt={-2}
              >
                <Grid container spacing={2}>
                  <Grid item xs={12} lg={12}>
                    <MDBox
                      display="flex"
                      flexDirection={{ xs: "column", lg: "row" }}
                      alignItems="center"
                      width="100%"
                    >
                      <MDBox
                        width={{ xs: "100%", lg: "400px" }}
                        mb={{ xs: 2, lg: 0 }}
                        mr={{ lg: 2 }}
                      >
                        <MDTypography variant="h6" style={{ fontWeight: 500 }}>
                          List of Warehouses
                        </MDTypography>
                        <Select
                          isClearable
                          placeholder="Choose One..."
                          className="select-css-for-filter"
                          maxMenuHeight={380}
                          autoComplete="off"
                          value={warehouseIdSelected}
                          options={warehouseOptions}
                          onChange={handleChangeWarehouse}
                        />
                      </MDBox>
                      <MDBox
                        width={{ xs: "100%", lg: "400px" }}
                        mb={{ xs: 2, lg: 0 }}
                        mr={{ lg: 2 }}
                      >
                        <MDTypography variant="h6" style={{ fontWeight: 500 }}>
                          All Stock
                        </MDTypography>

                        <Select
                          isClearable
                          placeholder="Choose One..."
                          className="select-css-for-filter"
                          maxMenuHeight={380}
                          autoComplete="off"
                          value={selectedAllStock}
                          options={allStockOptions}
                          onChange={handleStockChange}
                        />
                      </MDBox>

                      <MDBox
                        style={{
                          marginTop: "25px",
                          marginLeft: { xs: 0, lg: "8px" },
                        }}
                      >
                        <CSVLink {...csvLink}>
                          <DownloadDataButton
                            type="button"
                            variant="outlined"
                            style={{ borderRadius: "5px" }}
                            size="small"
                            color="success"
                            iconOnly
                            tooltip="Download All Data"
                          >
                            <Icon>download</Icon>
                          </DownloadDataButton>
                        </CSVLink>
                      </MDBox>
                    </MDBox>
                  </Grid>
                </Grid>
              </MDBox>
              <Modal
                open={openCreateColumnReorderModal}
                onClose={handleCloseCreateColumnReorderModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                style={{ backdropFilter: "blur(5px)" }}
              >
                <MDCard sx={styleForColumnReorder}>
                  <MDTypography>Are you sure you want to submit?</MDTypography>
                  <MDBox mt={2}>
                    <MDButton
                      style={{ width: "10rem", marginRight: "0.5rem" }}
                      color="info"
                      variant="outlined"
                      onClick={handleCloseCreateColumnReorderModal}
                    >
                      Cancel
                    </MDButton>
                    <MDButton
                      style={{ width: "10rem", marginLeft: "0.5rem" }}
                      color="success"
                      onClick={handleDynamicColumn}
                      // disabled={denyButtonName === "Please wait..."}
                    >
                      Submit
                    </MDButton>
                  </MDBox>
                  <MDBox mt={2}>
                    <Collapse in={isSuccessColumnReorder}>
                      <Alert
                        severity="success"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsSuccessColumnReorder(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        Data updated successfully!
                      </Alert>
                    </Collapse>
                    <Collapse in={isErrorColumnReorder}>
                      <Alert
                        severity="error"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsErrorColumnReorder(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        {isErrorMsgForColumnReorder}
                      </Alert>
                    </Collapse>
                  </MDBox>
                </MDCard>
              </Modal>

              <MDBox pt={3}>
                <DataTable
                  table={{ columns, rows }}
                  isSorted={true}
                  tableSearch={true}
                  entriesPerPage={{
                    defaultValue: 5,
                    entries: [5, 10, 15, 20, 25, 30],
                  }}
                  showTotalEntries={true}
                  noEndBorder
                  serverSidePagination={true}
                  paginationObj={paginationObj}
                  pageNoValue={pageNo}
                  rowsPerPageValue={rowsPerPage}
                  pageNoProp={importPageNo}
                  rowsPerPageProp={importRowsPerPage}
                  searchProp={importSearch}
                  loading={loading}
                  hideColumns={hiddenColumsDetails}
                  visibleColumns2={dynamicColumnData?.visibleFields}
                  dynamicColumnData={dynamicColumnData}
                  handleOpenCreateColumnReorderModal={
                    handleOpenCreateColumnReorderModal
                  }
                  subModuleId={subModuleId}
                  userId={userId}
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      {loading && (
        <Backdrop
          sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <ToastContainer />
      {loading && (
        <Backdrop
          sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
    </DashboardLayout>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,

    getSuidsReducer: state.getSuidsReducer,
    warehouses: state.warehouses,
    getWmsStockReducer: state.getWmsStockReducer,
    downloadWmsStockReducer: state.downloadWmsStockReducer,

    getDynamicColumnReducer: state.getDynamicColumnReducer,
  };
};

const mapStateToDispatch = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
    getWarehouses: (jwtToken) => dispatch(getWarehouses(jwtToken)),
    getWmsStock: (rowsPerPage, searchObject, warehouseId, status, jwtToken) =>
      dispatch(
        getWmsStock(rowsPerPage, searchObject, warehouseId, status, jwtToken),
      ),

    getWmsStockDownload: (
      rowsPerPage,
      searchObject,
      warehouseId,
      status,
      jwtToken,
    ) =>
      dispatch(
        getWmsStockDownload(
          rowsPerPage,
          searchObject,
          warehouseId,
          status,
          jwtToken,
        ),
      ),

    getSuids: (itemId, jwtToken) => dispatch(getSuids(itemId, jwtToken)),
    getDynamicColumn: (userId, subModuleId, jwtToken) =>
      dispatch(getDynamicColumn(userId, subModuleId, jwtToken)),
    createDynamicColumn: (payload, jwtToken) =>
      dispatch(createDynamicColumn(payload, jwtToken)),
  };
};

export default connect(mapStateToProps, mapStateToDispatch)(WmsStock);
